module.exports = __webpack_public_path__ + "img/ab07843685f4dff17c6970b43e161cc1.png";